import React from 'react';
import './css/NoItems.css';

export default () => (
	<span className="no-items">No items to show.</span>
);
